// src/polyfills.js
import { Buffer } from 'buffer';
// Делаем Buffer доступным глобально
window.Buffer = Buffer;